import { Divider, Heading, Stack } from '@chakra-ui/react'
import { chain } from 'lodash'
import { useCallback, useMemo, useRef } from 'react'
import useProgressionQuery from '../../hooks/useProgressionQuery'
import { ProgressionQueryParams } from '../../types/ProgressionQuery'
import QueryForm from './components/QueryForm'
import QueryResultsExport from './components/QueryResultsExport'
import QueryResultsPagination from './components/QueryResultsPagination'
import QueryResultsTable from './components/QueryResultsTable'

export default function ProgressionQueryPage() {
  const { hits, loading, pagination, executeQuery } = useProgressionQuery()
  const lastParamsRef = useRef<ProgressionQueryParams | null>(null)

  const displayMonths = useMemo(() => {
    return chain(hits)
      .map((user) => user.scores)
      .flatten()
      .map((s) => s.month)
      .uniq()
      .sort()
      .value()
  }, [hits])

  const handleSubmit = useCallback(
    async (params: ProgressionQueryParams) => {
      lastParamsRef.current = params
      await executeQuery(params, 0)
    },
    [executeQuery]
  )

  const handlePageChange = useCallback(
    (offset: number) => {
      if (lastParamsRef.current) {
        executeQuery(lastParamsRef.current, offset)
      }
    },
    [executeQuery]
  )

  return (
    <Stack spacing={6}>
      <Heading>Progression Query</Heading>
      <QueryForm onSubmit={handleSubmit} isLoading={loading} />
      {hits.length > 0 && (
        <>
          <Divider />
          <QueryResultsPagination
            offset={pagination.offset}
            limit={pagination.limit}
            total={pagination.total}
            hasMore={pagination.hasMore}
            onPageChange={handlePageChange}
            isLoading={loading}
          />
          <QueryResultsTable hits={hits} displayMonths={displayMonths} />
          <QueryResultsPagination
            offset={pagination.offset}
            limit={pagination.limit}
            total={pagination.total}
            hasMore={pagination.hasMore}
            onPageChange={handlePageChange}
            isLoading={loading}
          />
          <QueryResultsExport hits={hits} />
        </>
      )}
    </Stack>
  )
}
